export default __webpack_public_path__ + "static/media/roadmap2.ded7b18e.png";